import type { BasePaymentOption } from "@/types/pricing";

/** Square catalog variation IDs (matches backend validation). */
export function isValidSquarePlanId(id: string | undefined | null): boolean {
  if (!id) return false;
  const trimmed = id.trim();
  return (
    trimmed.length >= 15 &&
    trimmed.length <= 40 &&
    /^[A-Z0-9]+$/.test(trimmed)
  );
}

/** True when this option already has a persisted plan link. */
export function isPaymentPlanLinked(option: BasePaymentOption): boolean {
  if (option.planType === "FULL_PAY") {
    return Boolean(option.slug?.trim());
  }
  return isValidSquarePlanId(option.squarePlanId);
}

/** Pricing fields cannot change after Square / slug link exists. */
export function isPaymentPricingLocked(option: BasePaymentOption): boolean {
  return isPaymentPlanLinked(option);
}

const GENERIC_PAYMENT_OPTION_PATTERNS = [
  /^bi[- ]?weekly(\s+plan)?$/i,
  /^monthly(\s+plan)?$/i,
  /^full(\s+pay|\s+payment(\s+plan)?)?$/i,
  /^full\s+plan$/i,
  /^daily(\s+plan)?$/i,
  /^pay in full$/i,
  /^payment plan$/i,
  /^installments?$/i,
];

/** Warn-only: generic names are hard to find in Subscriptions admin. */
export function isGenericPaymentOptionName(name: string | undefined | null): boolean {
  const trimmed = name?.trim();
  if (!trimmed) return false;
  return GENERIC_PAYMENT_OPTION_PATTERNS.some((pattern) =>
    pattern.test(trimmed)
  );
}
